module.exports = __webpack_public_path__ + "static/media/back.b05e7e4a.svg";